module.exports = (properties) => {
  const isCanvas = !!(properties && properties.videoSource?.canvas);
  const hasVideoContentHint = !!(properties && 'videoContentHint' in properties);
  // eslint-disable-next-line no-param-reassign
  if (isCanvas && !hasVideoContentHint) properties.videoContentHint = 'detail';
};
